import { getFromNetwork } from './server'

const COINGECKO_URL = 'https://api.coingecko.com/api/v3/simple/price'

// const DAPP_HOST = process.env.DAPP_HOST || "localhost";
// const DEVNET_DAPP_URL = `https://${DAPP_HOST}`;

// const testDataProviderUrl = process.env.TEST_DATA_PROVIDER_URL ?? "http://localhost";

// YSYS TODO: tokens was used for coingecko and not used anymore?
export const tokens = ['ethereum', 'dai', 'usd-coin', 'tether', 'wrapped-steth', 'bitcoin', 'lords']
export const tokensBraavos = ['eth', 'dai', 'usdc', 'usdt', 'wsteth', 'wbtc', 'lords', 'lusd', 'reth', 'strk', 'uni']

export const fetchPrices = async () => {
    let result = {}
    try {
        result = await getFromNetwork(`${COINGECKO_URL}?vs_currencies=usd&ids=${tokens.join(',')}`)
    } catch (e) {
        console.log('ERROR in fetchPrices: ', e)
    }
    // console.log('BRAAVOS PRICES ', await fetchPricesBraavos())
    return result
}

export const fetchPricesBraavos = async () => {
    // https://price.braavos.app/prices?symbols=eth,wsteth,dai
    let result = [] as { currency: string; price: number; symbol: string; timestamp: number }[]
    let response = {} as Record<string, { currency: string; usd: number; symbol: string; timestamp: number }>
    try {
        result = await getFromNetwork(`https://price.braavos.app/prices?symbols=${tokensBraavos.join(',')}&currency=usd`)
        result.map((item) => {
            if (item.symbol) response[item.symbol] = { currency: item.currency, symbol: item.symbol, usd: item.price, timestamp: item.timestamp }
        })
    } catch (e: any) {
        console.log('ERROR in fetchPrices: ', e.message)
    }

    return response
}
